var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          attrs: {
            "left-side-class": "col-xl-4",
            page: _vm.pageConfig,
            "right-side-class":
              "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "action-button",
                {
                  attrs: { i: "fas fa-arrow-circle-left", variant: "success" },
                  on: {
                    click: function($event) {
                      return _vm.$router.go(-1)
                    }
                  }
                },
                [_vm._v(" Regresar ")]
              ),
              _vm.isProvisionalRemedy
                ? _c(
                    "action-button",
                    {
                      attrs: {
                        i: "fas fa-print",
                        variant: "outline-success ml-2"
                      },
                      on: { click: _vm.handleDownloadReportRP }
                    },
                    [_vm._v(" Imprimir Propuesta ")]
                  )
                : _vm._e(),
              _vm.canResetDetermination && !_vm.showDetermination
                ? _c(
                    "action-button",
                    {
                      attrs: {
                        id: "btnResetDetermination",
                        i: "fas fa-undo",
                        variant: "success ml-2"
                      },
                      on: { click: _vm.onResetDeterminationHandler }
                    },
                    [_vm._v(" Regresar Determinación ")]
                  )
                : _vm._e(),
              _vm.canDetermineProposalRequest && !_vm.showDetermination
                ? _c("div", { staticClass: "dropdown ml-2" }, [
                    _vm.canDetermineProposalRequest
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-dropdown-actions w-100 dropdown-toggle float-left color-white bg-green font-weight-bold d-flex justify-content-center align-items-center mr-2 px-2",
                            attrs: {
                              "aria-expanded": "false",
                              "aria-haspopup": "true",
                              "data-toggle": "dropdown",
                              type: "button"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-flag-alt mx-2 pr-1 mt-2"
                            }),
                            _c("span", { staticClass: "mr-1" }, [
                              _vm._v("Determinar")
                            ])
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "dropdown-menu dropdown-menu-right custom-dropdown-container",
                        attrs: { "aria-labelledby": "dropdownMenuButton" }
                      },
                      [
                        _vm.canRecommendProposalRequest
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-item cursor-pointer mb-1",
                                on: {
                                  click: function($event) {
                                    return _vm.onOpenDeterminationHandler(
                                      _vm.proposalRequestStatusEnum
                                        .Recommendation
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-check text-green mr-2"
                                }),
                                _vm._v(" Recomendar ")
                              ]
                            )
                          : _vm._e(),
                        _vm.isProvisionalRemedy &&
                        _vm.canRecommendProposalRequest &&
                        _vm.information.statusId !=
                          _vm.proposalRequestStatusEnum.PartialRecommendation
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-item cursor-pointer mb-1",
                                on: {
                                  click: function($event) {
                                    return _vm.onOpenDeterminationHandler(
                                      _vm.proposalRequestStatusEnum
                                        .PartialRecommendation
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-check text-yellow mr-2"
                                }),
                                _vm._v(" Recomendado Parcial ")
                              ]
                            )
                          : _vm._e(),
                        _vm.canNotRecommendProposalRequest
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-item cursor-pointer mb-1",
                                on: {
                                  click: function($event) {
                                    return _vm.onOpenDeterminationHandler(
                                      _vm.proposalRequestStatusEnum
                                        .Not_Recommendation
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-times-circle text-red mr-2"
                                }),
                                _vm._v(" No Recomienda ")
                              ]
                            )
                          : _vm._e(),
                        _vm.isProvisionalRemedy
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-item cursor-pointer mb-1",
                                on: {
                                  click: function($event) {
                                    return _vm.onOpenDeterminationHandler(
                                      _vm.proposalRequestStatusEnum
                                        .RequirementsDoesNotAccomplish
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-times-circle text-red mr-2"
                                }),
                                _vm._v(" No Cumple Requisitos ")
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm.showDetermination
        ? _c("proposal-request-determination", {
            staticClass: "mb-3",
            attrs: {
              "determination-status-id": _vm.determinationStatusId,
              "is-for-reset-determination": _vm.isForResetDetermination,
              "proposal-request-id": _vm.proponentProfileId,
              "proposal-request-number": _vm.information.proposalNumber
            },
            on: {
              "on-cancel": _vm.onCancelDeterminationHandler,
              saved: _vm.onSavedDeterminationHandler
            }
          })
        : _vm._e(),
      _c("board", { staticClass: "mb-4", attrs: { details: _vm.board } }),
      _c(
        "custom-tab",
        { attrs: { "content-class": "mt-3", "no-nav-style": true } },
        [
          _c(
            "custom-tab-item",
            { attrs: { active: true, lazy: "", title: "Perfil Proponente" } },
            [
              _c("general-information", {
                attrs: {
                  data: _vm.information,
                  "is-professional-services": _vm.isProfessionalServices,
                  "is-provisional-remedy-area": _vm.isProvisionalRemedy
                }
              }),
              _vm.isProvisionalRemedy || _vm.isProfessionalServices
                ? _c("geographic-areas", {
                    attrs: { items: _vm.information.serviceCenters }
                  })
                : _vm._e(),
              _vm.isProvisionalRemedy
                ? _c("provided-services", {
                    attrs: {
                      evaluations: _vm.information.aditionalEvaluationServices,
                      therapies: _vm.information.therapyServices
                    }
                  })
                : _vm._e(),
              _c("proposal-request-documents", {
                attrs: {
                  "can-delete-document": _vm.canDetermineProposalRequest,
                  documents: _vm.documents
                },
                on: { donwload: _vm.downloadDocument, view: _vm.viewDocument }
              })
            ],
            1
          ),
          _vm.isProvisionalRemedy
            ? _c(
                "custom-tab-item",
                { attrs: { lazy: "", title: "Detalles de la Propuesta" } },
                [
                  _c("proposal-details", {
                    attrs: { "proposal-request-id": _vm.proponentProfileId }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "custom-tab-item",
            { attrs: { lazy: "", title: "Historial" } },
            [
              _c("proposal-request-status-history", {
                ref: "proposalStatusHistoryRef",
                attrs: { "proposal-request-id": _vm.proponentProfileId }
              })
            ],
            1
          ),
          _vm.canDocumentAccess
            ? _c(
                "custom-tab-item",
                { attrs: { lazy: "", title: _vm.documentsTabTitle } },
                [
                  _c("proposal-determination-documents", {
                    attrs: {
                      "is-provisional-remedy-area": _vm.isProvisionalRemedy
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isProvisionalRemedy
            ? _c(
                "custom-tab-item",
                { attrs: { lazy: "", title: "Bitácora" } },
                [_c("bitacora-manager")],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }